import { useDispatch } from "react-redux";
import useEndSessionBase from "@wine2trace/auth/useEndSession";
import { clearSessionState } from "../services/clearLocalSession";
import { socket } from "../socket";

// Chiusura locale della sessione (@wine2trace/auth) piu' lo stato della webapp:
// Redux (impersonazione, cantine: per non portare wineryid/clientname vecchi
// nel login successivo) e socket. Callback stabile.
const useEndSession = () => {
  const dispatch = useDispatch();

  return useEndSessionBase({
    onEnd: () => {
      clearSessionState(dispatch);
      socket.disconnect();
    },
  });
};

export default useEndSession;
